import { Button, Card, CardFooter, CardHeader } from "@/components/ui";
import type { CustomerReviewWrapperProps } from "./types";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  useCarousel,
} from "@/components/ui/carousel";
import { IconButton } from "@/components/ui/icon-button";
import { useState } from "react";
import { CustomerReviewModal } from "./customer-review-modal";
import { CustomerReviewRating } from "./customer-review-rating";

export const CustomerReviewWrapper = ({
  children,
  averageRating,
  total,
  serviceName,
}: CustomerReviewWrapperProps) => {
  const [openModalAllReviews, setOpenModalAllReviews] = useState(false);

  const handleViewAll = () => {
    setOpenModalAllReviews(true);
  };

  return (
    <>
      <Card className="border-0 md:border">
        <CardHeader className="flex flex-row items-center justify-between border-secondary-border md:border-b">
          <CustomerReviewRating averageRating={averageRating} total={total} />
          <Button
            variant="secondary"
            color="CTA2"
            size="sm"
            rounded="full"
            onClick={handleViewAll}
          >
            View all
          </Button>
        </CardHeader>
        <Carousel>
          <CarouselContent>
            {children.map((item, idx) => {
              return (
                <CarouselItem key={idx} className="basis-11/12 md:basis-full">
                  {item}
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CustomerReviewWrapperNavigation />
        </Carousel>
      </Card>
      <CustomerReviewModal
        open={openModalAllReviews}
        onClose={() => setOpenModalAllReviews(false)}
        serviceName={serviceName}
      />
    </>
  );
};

const CustomerReviewWrapperNavigation = () => {
  const { scrollPrev, scrollNext, canScrollPrev, canScrollNext } =
    useCarousel();
  return (
    <CardFooter className="hidden flex-row items-center justify-center gap-2 border-t border-secondary-border p-2 md:flex">
      <IconButton
        variant="secondary"
        color="foreground"
        rounded="full"
        size="sm"
        iconName="caretLeft"
        disabled={!canScrollPrev}
        onClick={scrollPrev}
      />
      <IconButton
        variant="secondary"
        color="foreground"
        rounded="full"
        size="sm"
        iconName="caretRight"
        disabled={!canScrollNext}
        onClick={scrollNext}
      />
    </CardFooter>
  );
};
